/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleKanbanState.js'
import mutations from './moduleKanbanMutations.js'
import actions from './moduleKanbanActions.js'
import getters from './moduleKanbanGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
